import type { PlaylistSummary } from '@blackblack/shared';
import { Link } from '../../lib/router';
import { Icon } from '../../components/ui/Icon';
import { Cover } from '../music/Cover';
import styles from '../music/music.module.css';

export function PlaylistCard({ playlist: p, showOwner }: { playlist: PlaylistSummary; showOwner?: boolean }) {
  return (
    <Link to={`/playlist/${p.id}`} className={styles.card}>
      <span className={styles.cardArt}>
        <Cover src={p.coverUrl} size="100%" radius={14} />
      </span>
      <span className={styles.cardTitle}>{p.title}</span>
      <span className={styles.cardSub}>
        {!p.isPublic && <Icon name="lock" size={11} />} {showOwner ? `Van ${p.owner.displayName}` : `${p.trackCount} nummers`}
      </span>
    </Link>
  );
}
